<div class="sidebar_container" id="sidebar-desktop">
  <div class="perfil image_perfil-repeat">
    <div class="menu">
      <div class="perfil_info__loading" *ngIf="carregandoPerfil">
        <div class="loading__foto">
          <ngx-skeleton-loader appearance="circle" count="1" [theme]="{
              width: '70px',
              height: '70px'
            }"></ngx-skeleton-loader>
          <div class="foto__texto">
            <ngx-skeleton-loader count="2" [theme]="{
                'border-radius': '20px',
                height: '20px',
                'margin-bottom': '8px',
                width: '200px'
              }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="perfil_info" *ngIf="!carregandoPerfil">
        <div class="perfil_info_foto">
          <dynamic-form [fields]="regConfigImagemPerfil"></dynamic-form>
        </div>
        <div class="perfil_info_dados">
          <dynamic-form [fields]="regConfigDadosMembro"></dynamic-form>
        </div>
      </div>
      <div class="grid">
        <div class="grid-item" *ngFor="let item of menuItems" (click)="acessarPagina(item)">
          <img class="icone_item-menu" [src]="item.imgIcon" />
          <label class="cs_label label_item-menu">{{ item.label }}</label>
        </div>
      </div>
    </div>
    <app-pontos-expirar></app-pontos-expirar>
  </div>
  <!-- <div class="separador">
    <img class="separador_icone" src="assets/images/icons/notificacao.png" />
    <label class="cs_label separador_label">Nível</label>
  </div> -->
  <!-- <div class="nivel_desafios">
    <div class="loading__nivel" *ngIf="carregandoPerfil">
      <div class="nivel__texto">
        <ngx-skeleton-loader
          count="3"
          [theme]="{
            'border-radius': '20px',
            height: '14px',
            'margin-bottom': '4px',
            width: '200px'
          }"
        ></ngx-skeleton-loader>
      </div>
      <ngx-skeleton-loader
        appearance="circle"
        count="1"
        [theme]="{
          width: '70px',
          height: '70px'
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="perfil_info_graficos" *ngIf="!carregandoPerfil">
      <dynamic-form [fields]="regConfigProximoNivel"></dynamic-form>
    </div>
    <div class="desafios">
      <dynamic-form [fields]="regConfigDesafios"></dynamic-form>
    </div>
  </div> -->

  <!-- <div class="notificacoes">
    <app-notificacoes></app-notificacoes>
  </div> -->

  <!-- <div class="desktop-sidebar__faq"> -->
  <!-- <app-faq [tipoVisualizacao]="'Desktop'"></app-faq> -->
  <!-- </div> -->
</div>